export default __webpack_public_path__ + "static/collage-9-ac6949e117205b95c13b93ef5ac2a7b1.jpg";